import Bowser from 'bowser';
class BowserState {
    constructor() {
        this.isMobile = () => this.bowser.platform.type === 'mobile';
        this.isIe = () => this.bowser.browser.name === 'Internet Explorer';
        const parser = Bowser.getParser(window.navigator.userAgent);
        this.bowser = {
            browser: parser.getBrowser(),
            platform: parser.getPlatform(),
        };
    }
}
export default new BowserState();
